import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { locationSchema as schema } from '../../_validationSchema';
import { locationAction as actions } from '../../_action/location.action';
import { location_model as model } from '../../_model';
import { locationConstants as constants } from '../../_constants';
import { siteConstants as site_constants } from '../../_constants';

import { useSelector } from 'react-redux';

const Location = (props) => {
  const { t } = props;

  const header = { name: 'Location', icon: 'cubes' };
  const reducer = useSelector((state) => state.locationOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'location';
  const menuCode = 'M_LOCATION';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Location' },
    { title: t('site'), field: 'Site' },
  ];
  let useService = () => {
    return [schema, actions, model, constants, site_constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);
  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(Location);
